import { notifyActions } from 'config/constants';

const INITIAL_STATE = {
  show: false,
  config: {
    message: 'teste',
    headline: 'teste',
    type: 'danger',
    timeout: null,
  },
};

export default function NotifcationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case notifyActions.SHOW:
      return { ...state, config: action.payload };
    case notifyActions.TOGGLE_SHOW:
      return { ...state, show: !state.show };
    case notifyActions.CHANGE_SHOW:
      return { ...state, show: action.payload };
    default:
      return state;
  }
}
